<template>
    <div name="marketing">
        <div class="header">
            <div class="button-area" @click="back">
                <img class="back" src="../../assets/back.png" />
            </div>
            <span>광고성 정보 수신</span>
        </div>
        <div v-if="policies !== null" style="margin-top: 30px; padding: 20px;">
            <span class="title">변경 이력</span>
            <div class="list">
                <div v-for="(policy, index) in policies">
                    <span v-if="policy.id != 1" class="label">{{convertTimestamp(policy.revisionDate)}} 개정</span><span v-else class="label">{{convertTimestamp(policy.revisionDate)}} 제정</span> <span class="link" v-if="selected != policy.id" @click="selectRevision(policy.id)">- 확인하러 가기</span>
                </div>
            </div>
        </div>
        <div style="margin-top: 50px">
            <contents20230314 v-if="selected === 1" />
            <contents20250219 v-if="selected === 2" />
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import contents20230314 from '@/pages/partners/contents/advertisement/20230314';
import contents20250219 from '@/pages/partners/contents/advertisement/20250219';

export default {
    name: 'marketing',
    components: {
        contents20230314,
        contents20250219
    },
    data: function()
    {
        return {
            policies: [
                {
                    revisionDate: '2025-02-19',
                    id: 2
                },
                {
                    revisionDate: '2023-03-14',
                    id: 1
                },

            ],
            selected: 2,
            content: null
        }
    },
    methods: {
        selectRevision: function(index)
        {
            this.selected = index;
        },
        convertTimestamp: function(stamp)
        {
            
            var date = new Date(stamp);
            var month = date.getMonth() + 1;
            var text = '오전';
            var hour = date.getHours();
            if(date.getHours() >= 12)
            {
                text = '오후'

                if(hour != 12)
                {
                    hour = hour - 12;
                }
            }

            return date.getFullYear() + "년 " + this.leadingZeros(month, 2) + "월 " + this.leadingZeros(date.getDate(), 2) + "일 ";
        },
        leadingZeros: function(n, digits) {
            var zero = '';
            n = n.toString();
            if (n.length < digits) {
                for (var i = 0; i < digits - n.length; i++)
                    zero += 0;
            }
            return zero + n;
        },
        back: function()
        {
            this.$router.push({path: '/partners'})
        }
    }
}
</script>

<style scoped>
    .title {
        font-size: 18px;
    }
    .label {
        font-size: 15px;
        color: gray;
    }
    .list {
        display: flex;
        flex-direction: column;
        gap: 3px;
        margin-top: 10px;
    }
    .link {
        text-decoration: underline;
        cursor: pointer;
        color: blue;
        font-size: 15px;
    }
    .header{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .back {
        width: 15px;
        margin-top: -2px;
    }
    .button-area {
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/partners/Advertisement.vue